<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @export="exportFile"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          amzReplenishmentCode: chooseTemplateOptions.amzReplenishmentCode,
        },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        amzReplenishmentCode: '',
        templateGroup: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-replenishmentPurchaseReply-detail',
        params: { ...params, pageType },
        query,
      })
    },
    exportFile({ amzReplenishmentCode }, { templateGroup }) {
      this.chooseTemplateOptions = {
        visible: true,
        amzReplenishmentCode,
        templateGroup,
      }
    },
  },
}
</script>
